import { useState, useEffect, useContext } from 'react';
import { SessionContext } from '../../context/SessionProvider';
import authService from '../api-authorization/AuthorizeService'

const useFetch = (mainURL, skipAuth) => {
    const [url, su] = useState(null);
    const [data, setData] = useState(null);
    const [isPending, setIsPending] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);


    
    useEffect(() => {
        setUrl(mainURL);
    }, [mainURL])

    const setUrl = (url) => {
        
        su(url);
    }


    useEffect(() => {
        if (url != null) {
            const abortCont = new window.AbortController();

            if (skipAuth) {
                setIsLoaded(false);
                fetch(url, { signal: abortCont.signal })
                    .then(res => {
                        setIsLoaded(true);
                        if (!res.ok) { // error coming back from server
                            throw Error('could not fetch the data for that resource');
                        }
                        return res.json();
                    })
                    .then(data => {
                        setIsPending(false);
                        setData(data);
                        setError(null);
                    })
                    .catch(err => {
                        if (err.name === 'AbortError') {
                            console.log('fetch aborted')
                        } else {
                            // auto catches network / connection error
                            setIsPending(false);
                            setError(err.message);
                        }
                    })
            }
            else {
                const sss = authService.getAccessToken().then(token => {

                    setIsLoaded(false);
                    fetch(url, { signal: abortCont.signal, headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
                        .then(res => {
                            setIsLoaded(true);
                            if (!res.ok) { // error coming back from server
                                throw Error('could not fetch the data for that resource');
                            }
                            return res.json();
                        })
                        .then(data => {
                            setIsPending(false);
                            setData(data);
                            setError(null);
                        })
                        .catch(err => {
                            if (err.name === 'AbortError') {
                                console.log('fetch aborted')
                            } else {
                                // auto catches network / connection error
                                setIsPending(false);
                                setError(err.message);
                            }
                        })


                });
            }
            // abort the fetch
            return () => abortCont.abort();
        }
    }, [url])

    return { data, isPending, error, setData, setUrl, isLoaded };
}

export default useFetch;